<float-ui-content #popperMarkAllSelectedAsUnread>Označit vybrané jako nepřečtené</float-ui-content>
<float-ui-content #popperMarkAllSelectedAsRead>Označit vybrané jako přečtené</float-ui-content>
<float-ui-content #popperMarkAllAsRead>Označit vše jako přečtené</float-ui-content>

<ion-list>
  <ion-item class="grid-header">
    <ion-grid class="msg-item">
      <ion-row class="align-items-center">
        <ion-col size="20">
          <app-private-message-type-toggle *ngIf="messageDirection === 'inbound'"></app-private-message-type-toggle>
        </ion-col>

        <ion-col size="4" class="text-right">
          <ion-button color="tertiary" fill="clear" shape="round" size="small" (click)="toggleToolbarVisibility()">
            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="toolbarVisible">
        <ion-col>
          <ion-row class="align-items-center" *ngIf="allowFilters">
            <ion-col size="24">
              <ion-row class="ion-justify-content-end">
                <ion-col
                  size="12"
                  [style.display]="(service.inboundMsgType$ | async) === PrivateMessageQueryType.direct ? 'none' : null"
                >
                  <app-client-dropdown
                    title="Klient"
                    (changed)="filterByClientId.emit($event?.id)"
                  ></app-client-dropdown>
                </ion-col>

                <ion-col
                  size="12"
                  [style.display]="
                    (service.inboundMsgType$ | async) === PrivateMessageQueryType.feedback &&
                    !currentUser?.isOaCoordinator()
                      ? 'none'
                      : null
                  "
                >
                  <app-assistant-dropdown
                    *ngIf="currentUser?.isOaCoordinator()"
                    title="Asistent"
                    (changed)="filterByAssistantId.emit($event?.id)"
                  ></app-assistant-dropdown>

                  <app-coordinator-dropdown
                    *ngIf="!currentUser?.isOaCoordinator()"
                    title="Koordinátor"
                    (changed)="filterByUserId.emit($event?.id)"
                  ></app-coordinator-dropdown>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>

          <ion-row class="align-items-center" *ngIf="allowReadUnreadControl">
            <ion-col size="2" class="flex-vertical-center msg-checkbox-col">
              <span class="msg-checkbox">
                <ion-checkbox
                  class="ion-no-margin"
                  (ionChange)="fetchOnlyUnread.emit($event.detail.checked)"
                  aria-label="Pouze nepřečtené"
                ></ion-checkbox>
              </span>
            </ion-col>
            <ion-col>
              <span>Pouze nepřečtené</span>
            </ion-col>
          </ion-row>
          <ion-row class="align-items-center">
            <ion-col size="2" class="flex-vertical-center msg-checkbox-col">
              <span class="msg-checkbox">
                <ion-checkbox
                  class="ion-no-margin"
                  [checked]="areAllMessagesSelected()"
                  (ionChange)="toggleSelectAll($event.detail.checked)"
                  [indeterminate]="shouldBeSelectAllCheckboxIndeterminate(sortedMessages, selectedMessageIds)"
                  labelPlacement="start"
                  aria-label="Vybrat vše"
                ></ion-checkbox>
              </span>
            </ion-col>
            <ion-col>
              <span>Vybrat vše</span>
            </ion-col>
            <ion-col size="4">
              <ion-text *ngIf="selectedMessageIds.size">
                {{ selectedMessageIds.size }}
              </ion-text>
            </ion-col>
            <ion-col size="18" class="text-right action-buttons-col">
              <ion-grid>
                <ion-row>
                  <ion-col class="ion-text-right">
                    <div class="action-buttons-row">
                      <ion-button
                        color="primary"
                        fill="solid"
                        shape="round"
                        size="small"
                        [floatUi]="popperMarkAllSelectedAsUnread"
                        [showTrigger]="NgxFloatUiTriggers.hover"
                        (click)="markSelectedAsUnread()"
                        [disabled]="!selectedMessageIds.size"
                      >
                        <fa-icon [icon]="faEnvelope"></fa-icon>
                      </ion-button>
                      <ion-button
                        color="primary"
                        fill="solid"
                        shape="round"
                        size="small"
                        [floatUi]="popperMarkAllSelectedAsRead"
                        [showTrigger]="NgxFloatUiTriggers.hover"
                        (click)="markSelectedAsRead()"
                        [disabled]="!selectedMessageIds.size"
                      >
                        <fa-icon [icon]="faEnvelopeOpen"></fa-icon>
                      </ion-button>
                      <ion-button
                        color="primary"
                        fill="solid"
                        shape="round"
                        size="small"
                        *ngIf="allowReadUnreadControl"
                        [floatUi]="popperMarkAllAsRead"
                        [showTrigger]="NgxFloatUiTriggers.hover"
                        (click)="markAllAsReadWithConfirm()"
                      >
                        <fa-stack>
                          <fa-icon [icon]="faEnvelopeOpen" stackItemSize="1x" [inverse]="true"></fa-icon>
                          <fa-icon [icon]="faEnvelopeOpen" stackItemSize="1x" [transform]="{ x: 4, y: -4 }"></fa-icon>
                        </fa-stack>
                      </ion-button>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-item>

  <ng-container *ngIf="!!sortedMessages?.length; else suchEmpty">
    <ion-item
      *ngFor="let msg of sortedMessages; let i = index; trackBy: trackByMsg"
      (click)="openMessage(msg)"
      [ngClass]="{ unread: !msg.isRead }"
      class="grid-item"
    >
      <ion-grid class="msg-item">
        <ion-row>
          <ion-col size="2" class="flex-vertical-center msg-checkbox-col">
            <span class="msg-checkbox">
              <ion-checkbox
                (click)="$event.stopPropagation()"
                [checked]="isMessageChecked(msg.id)"
                (ionChange)="onMessageSelectionChange(msg, $event.detail.checked)"
                aria-label="Vybrat zprávu"
              ></ion-checkbox>
            </span>
          </ion-col>

          <ion-col size="16">
            <ion-row>
              <fa-icon [icon]="faAngleDoubleRight" class="msg-from-icon"></fa-icon>
              <span class="msg-from">{{ msg.publishedByUser.fullNameReverse() }}</span>
            </ion-row>

            <ion-row>
              <fa-icon *ngIf="msg.attachmentUri" [icon]="faPaperclip" class="attachment-icon"></fa-icon>
              <span *ngIf="msg.type === PrivateMessageType.assistantFeedback" class="msg-feedback">ZV</span>
              <span class="msg-title">{{ msg.title }}</span>
            </ion-row>

            <ion-row>
              <span class="msg-content" [innerHTML]="msg.content | stripTags: true"></span>
            </ion-row>
          </ion-col>

          <ion-col size="6" class="flex-vertical-center msg-last-column">
            <ion-row>
              {{ msg.publishedAt | date: 'dd.MM.yyyy HH:mm' }}
            </ion-row>
            <ion-row *ngIf="msg.type === PrivateMessageType.assistantFeedback">
              <span class="msg-assistance-link">
                <ion-button
                  color="tertiary"
                  fill="solid"
                  size="default"
                  (click)="
                    $event.stopPropagation(); openAssistance(msg.assistance_feedback_message.assignment.assistanceId)
                  "
                >
                  <fa-icon [icon]="faHandsHelping"></fa-icon>
                </ion-button>
              </span>
            </ion-row>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </ng-container>

  <ion-infinite-scroll #infiniteScroll threshold="100px" (ionInfinite)="loadMoreMessages()">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Načítám další zprávy..."
    ></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-list>

<ng-template #suchEmpty>
  <div class="flex-vertical-center h-100 such-empty">
    <div class="text-center">WOW, SUCH EMPTY</div>
  </div>
</ng-template>
